import React from 'react';
import logoLightImg from '../assets/mireva-logo.png';
import logoDarkImg from '../assets/mireva-logo-dark.png';
import clsx from 'clsx';

export default function BrandLogo({ 
  className = "h-[22px] sm:h-[24px] max-h-[26px] w-auto object-contain", 
  showBySanglob = false,
  bySanglobClassName = "text-[8px] text-slate-400 font-medium tracking-wide",
  dark = true
}) {
  const currentLogo = dark ? logoLightImg : logoDarkImg;

  return (
    <div className="inline-flex items-center h-full shrink-0 select-none">
      <img 
        src={currentLogo} 
        alt="MIREVA — Modern Intelligent Resource Enterprise & Value Analytics" 
        className={clsx(
          "w-auto object-contain select-none transition-all", 
          className
        )} 
        loading="eager"
      />
      {showBySanglob && (
        <span className={clsx("leading-none mt-0.5 font-medium ml-1.5", bySanglobClassName)}>
          by <span className={clsx("font-bold", dark ? "text-slate-200" : "text-slate-800")}>Sanglob</span>
        </span>
      )}
    </div>
  );
}
